export default __webpack_public_path__ + "static/media/amplify-logo.7aec3a6c.png";